import React, { useEffect } from "react";
import { keyframes, styled } from "goober";

import { classNames } from "@/util/class-names.mjs";
import { EVENT_FETCHING_DATA, events } from "@/util/hook-fetch.mjs";
import { proxy, useSnapshot } from "@/util/proxy.mjs";
import { useIsLoaded } from "@/util/router-hooks.mjs";

const anim = () => keyframes`
  0% {
    left: 0%;
    width: 0%;
  }

  50% {
    left: 0%;
    width: 100%;
  }

  100% {
    left: 100%;
    width: 0%;
  }
`;

const Wrapper = styled("div")`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  pointer-events: none;
  z-index: 999;

  overflow: hidden;
`;

const ActivityIndicator = styled("div")`
  position: relative;
  left: 0%;

  width: 0%;
  height: 3px;

  background: linear-gradient(
    to right,
    hsla(var(--primary-hsl-hover) / 0.75),
    hsla(var(--primary-hsl) / 1)
  );

  display: none;

  animation: ${anim} 1.5s ease infinite;

  &.visible {
    display: block;
  }
`;

const networkActivityRef = proxy({
  isFetching: false,
  isVisible: false,
});

function onFetchStart() {
  networkActivityRef.isFetching = true;
  networkActivityRef.isVisible = true;
}

const GlobalNetworkActivity = () => {
  const isLoaded = useIsLoaded(true);

  const { isFetching } = useSnapshot(networkActivityRef);

  useEffect(() => {
    if (isLoaded) {
      networkActivityRef.isFetching = false;
      return;
    }

    events.once(EVENT_FETCHING_DATA, onFetchStart);

    return () => {
      events.off(EVENT_FETCHING_DATA, onFetchStart);
    };
  }, [isLoaded]);

  return (
    <Wrapper>
      <ActivityIndicator {...classNames(isFetching && "visible")} />
    </Wrapper>
  );
};

export default GlobalNetworkActivity;
